import React from 'react';
import type { Contact } from '@hero/schema';
import { useContactDrawerStore } from '@hero/hooks-shared';
import { ContactIcon, PhoneIcon, MailIcon } from '@hero/web-icons';
import { Card } from '../../../app/Card/Card';

export interface ContactCardProps {
  contact: Contact;
  className?: string;
}

export const ContactCard: React.FC<ContactCardProps> = ({ contact, className }) => {
  const openDrawer = useContactDrawerStore(s => s.open);

  return (
    <Card onClick={() => openDrawer(String(contact._id))} className={className}>
      <div className="flex items-center gap-2 text-sm font-medium text-gray-700 min-w-0">
        <div className="flex items-center justify-center rounded-md bg-gray-50 p-1.5 flex-shrink-0">
          <ContactIcon className="size-3.5 text-gray-400" />
        </div>
        <span className="truncate">{contact.name}</span>
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
        {contact.phone && (
          <div className="flex items-center gap-1.5 text-xs text-gray-500">
            <PhoneIcon className="size-3 text-gray-400" />
            <span>{contact.phone}</span>
          </div>
        )}
        {contact.email && (
          <div className="flex items-center gap-1.5 text-xs text-gray-500">
            <MailIcon className="size-3 text-gray-400" />
            <span>{contact.email}</span>
          </div>
        )}
      </div>
    </Card>
  );
};
